import { LogsApiResponse } from './logs.models';
import { FilterOption } from '../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { TableFilterTab } from '../../../../ui-components/lib/table/table.model';
import { ENDPOINTS } from '../../../common/constants/endpoints.constants';

// when sorting flag is enabled, we will use LOGS_DEFAULT_COLUMNS_SORT instead of LOGS_DEFAULT_COLUMNS
export const LOGS_DEFAULT_COLUMNS_SORT = [
  {
    header: '',
  },
  {
    header: 'logs_list_screen_table_header_id_title',
    isSortable: true,
    sortKey: 'id][type',
  },
  {
    header: 'logs_list_screen_table_header_timestamp_title',
    isSortable: true,
    sortKey: 'created_at][type',
  },
  {
    header: 'logs_list_screen_table_header_user_name_title',
    isSortable: true,
    sortKey: 'causer][type',
  },
  {
    header: 'logs_list_screen_table_header_action_name_title',
    isSortable: true,
    sortKey: 'description][type',
  },
  {
    header: 'logs_list_screen_table_header_action_type_title',
    isSortable: true,
    sortKey: 'event][type',
  },
  {
    header: 'logs_list_screen_table_header_module_title',
    isSortable: true,
    sortKey: 'subject_type][type',
  },
  {
    header: 'logs_list_screen_table_header_reference_id_title',
    isSortable: true,
    sortKey: 'subject][type',
  },
];

export const LOGS_DEFAULT_COLUMNS = [
  {
    header: '',
  },
  {
    header: 'logs_list_screen_table_header_id_title',
  },
  {
    header: 'logs_list_screen_table_header_timestamp_title',
  },
  {
    header: 'logs_list_screen_table_header_user_name_title',
  },
  {
    header: 'logs_list_screen_table_header_action_name_title',
  },
  {
    header: 'logs_list_screen_table_header_action_type_title',
  },
  {
    header: 'logs_list_screen_table_header_module_title',
  },
  {
    header: 'logs_list_screen_table_header_reference_id_title',
  },
];

export const LOGS_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
];
export const LOGS_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'causerId',
    label: 'logs_list_screen_filter_assignee_label',
    type: 'paginated',
    apiUrl: ENDPOINTS.Lookup.User,
  },
  {
    key: 'event',
    label: 'logs_list_screen_filter_action_type_label',
    type: 'multi',
    apiUrl: ENDPOINTS.Logs.getFilterActionList,
    placeholder: 'logs_list_screen_filter_action_type_placeholder',
  },
  {
    key: 'subjectType',
    label: 'logs_list_screen_filter_module_label',
    type: 'multi',
    apiUrl: ENDPOINTS.Logs.getFilterSubjectTypeList,
    placeholder: 'logs_list_screen_filter_module_placeholder',
  },
  {
    key: 'creationDate',
    label: 'logs_list_screen_filter_creation_date_label',
    type: 'dateRange',
  },
];

export const logsDummyData: LogsApiResponse[] = [
  {
    id: 1,
    created_at: '2026-02-01T10:15:30Z',
    causer: {
      id: 101,
      name: 'Ahmed Ali',
      email: 'ahmed.ali@example.com',
    },
    event: {
      value: 'created',
      label: 'Created',
    },
    subject_id: 5001,
    subject_type: {
      label: 'User',
      value: 'App\\Models\\User',
    },
  },
  {
    id: 2,
    created_at: '2026-02-02T14:45:10Z',
    causer: {
      id: 102,
      name: 'Sara Mohamed',
      email: 'sara.mohamed@example.com',
    },
    event: {
      value: 'updated',
      label: 'Updated',
    },
    subject_id: 7003,
    subject_type: {
      label: 'Order',
      value: 'App\\Models\\Order',
    },
  },
  {
    id: 3,
    created_at: '2026-02-03T09:05:55Z',
    causer: {
      id: 103,
      name: 'Omar Hassan',
      email: 'omar.hassan@example.com',
    },
    event: {
      value: 'deleted',
      label: 'Deleted',
    },
    subject_id: 9002,
    subject_type: {
      label: 'Product',
      value: 'App\\Models\\Product',
    },
  },
];
